/**
 * SHER-441 / SHER-934 — the display name of an already-chosen coverage.
 *
 * A coverage's name embeds the percentage its `percentage` column already holds
 * ("Assemblée nationale 80%"), and one insurer exists once per band — 20 rows in
 * CHOM. Coverage is applied per PEC, not per patient, so wherever a *single*
 * coverage is displayed the honest label is the insurer's own name: a percentage
 * there reads as a promise the system does not make (SHER-934: the PEC form is the
 * only place the percentage lives).
 *
 * - A coverage linked to an insurer shows `insurance.name`, never its own name —
 *   that is where the percentage is. Until the insurer is in `insurances` (still
 *   loading) it shows nothing rather than the percentage.
 * - A coverage with no insurer link shows its stored name. These are the ~200
 *   coverages created before migration 1758517630399 dropped the link; their names
 *   are insurer names with no percentage ("AXA ASSURANCES", "PAF").
 * - `null` when there is no name at all: the caller renders "Unknown insurer".
 *
 * The selectors need no stripping: since SHER-934 they offer only each insurer's bare
 * coverage, labelled with the insurer's name.
 */
export function resolveCoverageDisplayName(
    coverage: { name?: string | null; insuranceId?: number | null } | null | undefined,
    insurances?: Array<{ id: number; name?: string | null }> | null,
): string | null {
    if (!coverage) {
        return '';
    }

    if (coverage.insuranceId == null) {
        return coverage.name?.trim() || null;
    }

    const insurance = (insurances || []).find((ins) => ins && ins.id === coverage.insuranceId);
    if (!insurance) {
        return '';
    }
    return insurance.name?.trim() || null;
}
